import { render, staticRenderFns } from "./BuscaClienteContato.vue?vue&type=template&id=42ca7c9e&scoped=true"
import script from "./BuscaClienteContato.vue?vue&type=script&lang=js"
export * from "./BuscaClienteContato.vue?vue&type=script&lang=js"
import style0 from "./BuscaClienteContato.vue?vue&type=style&index=0&id=42ca7c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca7c9e",
  null
  
)

export default component.exports